// Error codes returned by venuemonk-id auth endpoints. Must stay in sync with
// backend/venuemonk-id/src/common/constants/appConstants.js.

export const ERROR_DEVICE_CHANGE_REQUIRED = 'DEVICE_CHANGE_REQUIRED';
export const ERROR_SESSION_SUPERSEDED = 'SESSION_SUPERSEDED';
export const ERROR_ACCESS_DISABLED_APP = 'ACCESS_DISABLED_APP';
export const ERROR_ACCESS_DISABLED_WEB = 'ACCESS_DISABLED_WEB';

// Fallback user-facing messages. The backend now sends the authoritative,
// platform-aware text in `res.message` — callers should prefer that and fall
// back to these constants only when the server didn't include a message.
// This client is the web sales app, so wording is browser/web-specific.
export const MSG_DEVICE_CHANGE_REQUIRED = "We don't recognize this browser. A device-change request has been sent to your admin — you'll be able to sign in here only after they approve it.";
export const MSG_SESSION_SUPERSEDED = "You have been signed out of this browser because your account signed in from another browser.";
export const MSG_ACCESS_DISABLED_WEB = "Web access is disabled for your account. Please contact your administrator.";
export const MSG_ACCESS_DISABLED_APP = "Mobile app access is disabled for your account. Please contact your administrator.";
export const MSG_ACCESS_DISABLED = MSG_ACCESS_DISABLED_WEB; // legacy alias

export function getMessageForErrorCode(code) {
    switch (code) {
        case ERROR_DEVICE_CHANGE_REQUIRED: return MSG_DEVICE_CHANGE_REQUIRED;
        case ERROR_SESSION_SUPERSEDED: return MSG_SESSION_SUPERSEDED;
        case ERROR_ACCESS_DISABLED_APP: return MSG_ACCESS_DISABLED_APP;
        case ERROR_ACCESS_DISABLED_WEB: return MSG_ACCESS_DISABLED_WEB;
        default: return null;
    }
}
